import { Stack, Typography } from '@mui/material';
import { MprcChipChoice, MprcContainer } from 'components';
import { FeedItemDto } from 'generated/CoreApi_v1';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router";
import { KnowledgePaths } from 'routes/KnowledgeRouter';

////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publication: FeedItemDto;
}


////////////////////////////////////////////////////////////////////////////////////////////////

export const PublicationTopicsBox: React.FC<IProps> = ({ publication }) => {

    const { t } = useTranslation("knowledge");
    const navigate = useNavigate();

    if ((publication.topics ?? []).length == 0) return null;

    return (
        <>
            <MprcContainer margin="dense">
                <Typography variant="h3">{t("Publication.ContentPage.TopicsSubtitle")}</Typography>
            </MprcContainer>
            <Stack direction="row" flexWrap="wrap" justifyContent="flex-start" alignContent="flex-start">
                {(publication.topics ?? []).map(item => <MprcChipChoice onClick={() => navigate(KnowledgePaths.FeedTopic(item.id))} key={item.id} label={item.name} />)}
            </Stack>
        </>
    );
};
